<!-- Header -->
<ng-container *transloco="let convert;">
  @if (showBackLink) {
    <app-back-link
      class="back-link"
      location="top"
      [navigationExtras]="{ scrollToTop: true }"
      [firstInstance]="true">
    </app-back-link>
  }
  <div class="manage-inventory-header" id="manage-header" aria-hidden="false">
    <h1 id="main-content-focus" class="manage-inventory-header__heading pagination-focus d-md-inline-block" tabindex="-1" role="alert">
      {{ convert('sellModule.manageInventory.manageHeader.textManageInventory')}}
    </h1>
  </div>

  <div style="position: relative;">
    <div class="action_links" [class.tabs-visible]="isSellerAdvancedSearchEnabled">
      @if (hasPreferencesMembers$ | async) {
        <ng-content *ngTemplateOutlet="preferences"></ng-content>
      }

      <button
        data-track-trigger="modal"
        [attr.data-track-name]="multiVinModal.dialogHeadline"
        [attr.aria-label]="multiVinModal.dialogHeadline"
        class="manage-inventory-header__multi-vin-btn text-primary d-block d-md-inline-block btn p-0 ms-md-auto mb-2"
        (click)="openMicroModal('multi-vin-modal')"
        >
        <i aria-hidden="true" class="me-1 allycon-search"></i>
        {{ multiVinModal.dialogHeadline }}
      </button>
    </div>


    <!-- Tabs -->
    <div class="advanced_search">
      <tabset
        type="tabs"
        #staticTabs
        [class.hide-advanced-search]="!isSellerAdvancedSearchEnabled">

        <tab heading="{{ convert('sellModule.manageInventory.manageHeader.tabSearch')}}" (selectTab)="activeTab = 'Search'">
          <div class="card card--manage-inventory">
            <ng-container *ngTemplateOutlet="tmplSearch"></ng-container>
          </div>
        </tab>

        <tab heading="{{ convert('sellModule.manageInventory.manageHeader.tabAdvancedSearch')}}" (selectTab)="activeTab = 'Advanced Search'" class="advanced_search_tab">
          <div class="card card--manage-inventory">
            <ng-container *ngTemplateOutlet="tmplAdvancedSearch"></ng-container>
          </div>
        </tab>

      </tabset>
    </div>
  </div>


  <!-- Search -->
  <ng-template #tmplSearch>
    @if (isDesktop$ | async; as isDesktopQuery) {
      <form [formGroup]="searchForm" id="search-form" class="w-100" aria-hidden="false"
        allytm-form-tagged='true'>
        @if (isDesktopQuery.matches) {
          <div class="d-none d-md-flex">
            @if (hasLeadSellerMembers$ | async) {
              <div class="input-container me-4 manage-inventory-header__dealer-group">
                <label class="control-label text-uppercase">{{convert('sellModule.manageInventory.manageHeader.textGroup')}}</label>
                <app-dealer-group></app-dealer-group>
              </div>
            }
            <div class="input-container">
              <label for="search-by-vin" class="text-uppercase" id="search-by-vin__label">{{convert('sellModule.manageInventory.manageHeader.textSearchBy')}}</label>
              <input
                formControlName="vin"
                id="search-by-vin"
                type="text"
                placeholder="{{convert('sellModule.manageInventory.manageHeader.placeholderFull')}}"
                class="italic-placeholder form-control"
                [class.invalid]="searchForm.get('vin').errors"
                aria-labelledby="search-by-vin__label"
                aria-describedby="search-by-vin__description"
                [appTrack]="{ name: 'Sell VIN Input' }"
                />
              <div class="text-danger" aria-live="polite" aria-atomic="true" role="alert" id="search-by-vin__error">
                @if (searchForm.get('vin').errors) {
                  {{convert('sellModule.manageInventory.manageHeader.textEnterValidVIN')}}
                }
              </div>
            </div>
            <span class="or-text">{{convert('sellModule.manageInventory.manageHeader.textOr')}}</span>
            @if (isAdmin) {
              <div class="input-container">
                <label for="search-by-seller-legacy-id" class="text-uppercase" id="search-by-seller-legacy-id__label">{{convert('sellModule.manageInventory.manageHeader.textSearchBySellerLegacyId')}}</label>
                <input
                  formControlName="sellerLegacyId"
                  id="search-by-seller-legacy-id"
                  type="text"
                  inputmode="numeric"
                  pattern="^[0-9]{6}$"
                  placeholder="{{convert('sellModule.manageInventory.manageHeader.placeholderSellerLegacyId')}}"
                  class="italic-placeholder form-control"
                  [class.invalid]="searchForm.get('sellerLegacyId').errors"
                  aria-labelledby="search-by-seller-legacy-id__label"
                  aria-describedby="search-by-seller-legacy-id__description"
                  [appTrack]="{ name: 'Sell SellerLegacyId Input'}"
                  data-test-id="app-manage-header-e-textbox-seller-legacy-id"
                  [maxlength]="6"
                  />
                <div class="text-danger" aria-live="polite" aria-atomic="true" role="alert" id="search-by-seller-legacy-id__error" data-test-id="app-manage-header-e-error-text-seller-legacy-id">
                  @if (searchForm.get('sellerLegacyId').errors) {
                    {{convert('sellModule.manageInventory.manageHeader.textEnterValidSellerLegacyId')}}
                  }
                </div>
              </div>
            }
            @if (isAdmin) {
              <span class="or-text" data-test-id="app-manage-header-e-or-text-seller-legacy-id">{{convert('sellModule.manageInventory.manageHeader.textOr')}}</span>
            }
            <div class="input-container">
              <label for="search-by-stock-number" class="text-uppercase" id="search-by-stock-number__label"
                >{{convert('sellModule.manageInventory.manageHeader.textSearchByStock')}}</label
                >
                <input
                  formControlName="stockNum"
                  id="search-by-stock-number"
                  type="text"
                  class="form-control"
                  aria-labelledby="search-by-stock-number__label"
                  [appTrack]="{ name: 'Sell Stock # Input' }"
                  />
              </div>
              <!-- Tracking removed from button, handled with custom event -->
              <button
                data-track-elem="button"
                [attr.data-track-name]="searchTrackName$ | async"
                [attr.aria-label]="convert('sellModule.manageInventory.manageHeader.tabSearch')"
                class="btn btn-primary search-btn search_btn"
                (click)="search()"
                allytmln='searchButton'
                >
                <span class="search-btn__inner">{{convert('sellModule.manageInventory.manageHeader.tabSearch')}}</span><i class="allycon-glyph-chevron-right" aria-hidden="true"></i>
              </button>
            </div>
          }
          @if (!isDesktopQuery.matches) {
            <div class="d-md-none d-lg-none d-xl-none">
              @if (hasLeadSellerMembers$ | async) {
                <div class="input-container">
                  <label class="control-label text-uppercase mb-0">{{convert('sellModule.manageInventory.manageHeader.textGroup')}}</label>
                  <app-dealer-group></app-dealer-group>
                </div>
              }
              <div class="form-group">
                <div class="search-by">
                  <h2 class="search-by__heading">{{convert('sellModule.manageInventory.manageHeader.textSearchBY')}}</h2>
                  <div class="control-wrapper radios">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        class="custom-control-input"
                        id="question-1"
                        name="question-radios"
                        type="radio"
                        [checked]="mobileSearchMode === 'vin'"
                        value="vin"
                        (change)="mobileSearchMode = 'vin'"
                        (click)="changeSearchMode('vin')"
                        />
                      <label class="custom-control-label" for="question-1">{{convert('sellModule.manageInventory.manageHeader.textVIN')}}</label>
                    </div>
                    @if (isAdmin) {
                      <div class="custom-control custom-radio custom-control-inline" data-test-id="app-manage-header-e-mobile-radio-seller-legacy-id">
                        <input
                          class="custom-control-input"
                          id="question-3"
                          name="question-radios"
                          type="radio"
                          [checked]="mobileSearchMode === 'sellerLegacyId'"
                          value="vin"
                          (change)="mobileSearchMode = 'sellerLegacyId'"
                          (click)="changeSearchMode('sellerLegacyId')"
                          />
                        <label class="custom-control-label" for="question-3" data-test-id="app-manage-header-e-mobile-radio-label-seller-legacy-id">{{convert('sellModule.manageInventory.manageHeader.textSellerLegacyId')}}</label>
                      </div>
                    }
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        class="custom-control-input"
                        id="question-2"
                        name="question-radios"
                        type="radio"
                        [checked]="mobileSearchMode === 'stock'"
                        value="stock"
                        (change)="mobileSearchMode = 'stock'"
                        (click)="changeSearchMode('stock')"
                        />
                      <label class="custom-control-label" for="question-2">{{convert('sellModule.manageInventory.manageHeader.textStockUnit')}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-container">
                <!-- <input id="mobile-search" type="text" placeholder="Enter full VIN or last 6 digits" class="italic-placeholder" /> -->
                <!-- mobile vin input -->
                @if (mobileSearchMode === 'vin') {
                  <input
                    formControlName="vin"
                    id="mobile-search-vin"
                    type="text"
                    placeholder="Enter full VIN or last 6 digits"
                    class="italic-placeholder form-control"
                    [class.invalid]="searchForm.get('vin').errors"
                    [attr.aria-label]="convert('sellModule.manageInventory.manageHeader.textSearchBy')"
                    aria-describedby="search-by-vin__description"
                    />
                }
                <div class="text-danger" aria-live="polite" aria-atomic="true" role="alert" id="mobile-search-vin__error">
                  @if (searchForm.get('vin').errors && mobileSearchMode === 'vin') {
                    {{convert('sellModule.manageInventory.manageHeader.textEnterValidVIN')}}
                  }
                </div>
                @if (mobileSearchMode === 'sellerLegacyId') {
                  <input
                    formControlName="sellerLegacyId"
                    id="mobile-search-seller-legacy-id"
                    type="text"
                    inputmode="numeric"
                    pattern="^[0-9]{6}$"
                    placeholder="{{convert('sellModule.manageInventory.manageHeader.placeholderSellerLegacyId')}}"
                    class="italic-placeholder form-control"
                    [class.invalid]="searchForm.get('sellerLegacyId').errors"
                    [attr.aria-label]="convert('sellModule.manageInventory.manageHeader.textSearchBy')"
                    aria-describedby="search-by-seller-legacy-id__description"
                    data-test-id="app-manage-header-e-mobile-input-seller-legacy-id"
                    [maxlength]="6"
                    />
                }
                <div class="text-danger" aria-live="polite" aria-atomic="true" role="alert" id="mobile-search-seller-legacy-id__error" data-test-id="app-manage-header-e-mobile-mobile-error-text-seller-legacy-id">
                  @if (searchForm.get('sellerLegacyId').errors && mobileSearchMode === 'sellerLegacyId') {
                    {{convert('sellModule.manageInventory.manageHeader.textEnterValidSellerLegacyId')}}
                  }
                </div>
                <!-- mobile stock number input -->
                @if (mobileSearchMode === 'stock') {
                  <input
                    formControlName="stockNum"
                    id="mobile-search-stock"
                    type="text"
                    class="italic-placeholder form-control"
                    [attr.aria-label]="convert('sellModule.manageInventory.manageHeader.ariaLabelStockNumber')"
                    />
                }
              </div>
              <button
                data-track-elem="button"
                [attr.data-track-name]="searchTrackName$ | async"
                [attr.aria-label]="convert('sellModule.manageInventory.manageHeader.tabSearch')"
                class="btn btn-primary btn-wide search_btn"
                (click)="search()"
                >
                {{convert('sellModule.manageInventory.manageHeader.tabSearch')}}
              </button>
            </div>
          }
          <div class="visually-hidden" id="search-by-vin__description">
            {{convert('sellModule.manageInventory.manageHeader.textEnterMinimum')}}
          </div>
        </form>
      }
    </ng-template>


    <!-- Advanced Search -->
    <ng-template #tmplAdvancedSearch>
      <advanced-search-header></advanced-search-header>
    </ng-template>


    <!-- Preferences -->
    <ng-template #preferences>
      <trap-focus [enableFocusTrap]="!disableFocus && pop.isOpen" [enableArrowKeys]="!disableFocus">
        <button
          class="manage-inventory-header__open-edit-preferences btn btn-link d-md-inline-block p-0"
          role="button"
          #pop="bs-popover"
          [popover]="editPreferenceTemplate"
          (onShown)="onShowPreferencesPop()"
          (onHidden)="onHidePreferencesPop()"
          placement="bottom left"
          [adaptivePosition]="false"
          [outsideClick]="true"
          containerClass="manage-preferences-popover"
          data-track-elem="button"
          data-track-name="Edit Preferences"
          >
          <i class="me-1 allycon-settings" aria-hidden="true"></i>
          {{convert('sellModule.manageInventory.manageHeader.textEditPreference')}}
        </button>

        <ng-template #editPreferenceTemplate>
          <div class="p-3 preferences">
            <div class="d-flex justify-content-between">
              <div class="me-5 fw-bold align-self-center preferences__title">{{convert('sellModule.manageInventory.manageHeader.textDefaultPreferences')}}</div>
            </div>
            <div class="preferences__body my-3">
              <app-preferences-popover></app-preferences-popover>
            </div>
            <div class="preferences__action">
              <button
                class="btn btn-outline-primary w-100 preferences-btn"
                data-track-elem="button"
                data-track-name="Preferences - close"
                data-track-trigger="Save Preferences"
                (click)="savePreferences()"
                >
                {{convert('sellModule.manageInventory.manageHeader.textSavePreferences')}}
              </button>

              <button
                class="edit-preferences__close"
                (click)="$event.preventDefault(); pop.hide()"
                data-track-elem="button"
                data-track-name="Close"
                data-track-trigger="close"
                type="button"
                [attr.aria-label]="convert('common.btnClose')"
                id="ed_close_x_button"
                >
                <i class="allycon-x text-primary tenant-icons" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </ng-template>
      </trap-focus>
    </ng-template>


    <!-- Modals -->
    <lib-multi-vin-modal #multiVinModal></lib-multi-vin-modal>
  </ng-container>
